"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var hoist_non_react_statics_1 = tslib_1.__importDefault(require("hoist-non-react-statics"));
var React = tslib_1.__importStar(require("react"));
var getDisplayName_1 = tslib_1.__importDefault(require("recompose/getDisplayName"));
var contexts_1 = require("../contexts");
exports.withForwardRef = function (WrappedComponent) {
    var ForwardRefComponent = React.forwardRef(function (props, ref) { return React.createElement(WrappedComponent, tslib_1.__assign({ forwardRef: ref }, props)); });
    ForwardRefComponent.displayName = getDisplayName_1.default(WrappedComponent);
    ForwardRefComponent.defaultProps = WrappedComponent.defaultProps;
    hoist_non_react_statics_1.default(ForwardRefComponent, WrappedComponent);
    return ForwardRefComponent;
};
exports.withFocus = function (WrappedComponent) {
    var FocusableComponent = /** @class */ (function (_super) {
        tslib_1.__extends(FocusableComponent, _super);
        function FocusableComponent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                focus: false
            };
            _this.setFocus = function () {
                _this.setState(function (_a) {
                    var focus = _a.focus;
                    return ({
                        focus: !focus
                    });
                });
            };
            _this.resetFocus = function () {
                _this.setState({ focus: false });
            };
            return _this;
        }
        FocusableComponent.prototype.render = function () {
            var _this = this;
            var _a = this.props, onFocus = _a.onFocus, onBlur = _a.onBlur, forwardRef = _a.forwardRef, rest = tslib_1.__rest(_a, ["onFocus", "onBlur", "forwardRef"]);
            var focus = this.state.focus;
            return (React.createElement(WrappedComponent, tslib_1.__assign({ ref: forwardRef, focus: focus }, rest, { onFocus: function (event) {
                    _this.setFocus();
                    if (onFocus) {
                        onFocus(event);
                    }
                }, onBlur: function (event) {
                    _this.resetFocus();
                    if (onBlur) {
                        onBlur(event);
                    }
                } })));
        };
        return FocusableComponent;
    }(React.Component));
    return exports.withForwardRef(FocusableComponent);
};
exports.withAnnounce = function (WrappedComponent) {
    var ForwardRef = React.forwardRef(function (props, ref) { return (React.createElement(contexts_1.AnnounceContext.Consumer, null, function (announce) { return React.createElement(WrappedComponent, tslib_1.__assign({}, props, { announce: announce, ref: ref })); })); });
    ForwardRef.displayName = getDisplayName_1.default(WrappedComponent);
    ForwardRef.defaultProps = WrappedComponent.defaultProps;
    hoist_non_react_statics_1.default(ForwardRef, WrappedComponent);
    return ForwardRef;
};
//# sourceMappingURL=hocs.js.map